// src/utils/models/projectModel.js

export const PROJECT_STATUS = {
  MANAGING: 'managing',
  INSTALLING: 'installing',
  INSTALLED: 'installed',        // ← AÑADIDO
  COMPLETED: 'completed'
};

export const PROJECT_STATUS_LABELS = {
  managing: 'Gestionando',
  installing: 'Instalando',
  installed: 'Instalado',        // ← AÑADIDO
  completed: 'Finalizado'
};

export const INSTALLATION_TYPES = {
  PHOTOVOLTAIC: 'photovoltaic',
  EV_CHARGER: 'ev_charger',
  ELECTRIC_SUPPLY: 'electric_supply'  // ← AÑADIDO
};

export const INSTALLATION_TYPE_LABELS = {
  photovoltaic: 'Fotovoltaica',
  ev_charger: 'Cargador Eléctrico',
  electric_supply: 'Suministro Eléctrico'  // ← AÑADIDO
};

export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
};

export const TASK_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  REVIEW: 'review',
  DONE: 'done'
};

// Pasos de la guía de progreso
export const PROGRESS_STEPS = [
  { key: 'hasFileOpened', label: 'Apertura expediente', icon: '📂' },
  { key: 'hasLicensePermit', label: 'Licencia de obra', icon: '📋' },
  { key: 'materialPurchased', label: 'Recursos comprados', icon: '🛒' },
  { key: 'laborHired', label: 'Recursos coordinados', icon: '👷' },
  { key: 'installed', label: 'Instalación hecha', icon: '✅' },
];

export const STATUS_ORDER = [
  PROJECT_STATUS.MANAGING,
  PROJECT_STATUS.INSTALLING,
  PROJECT_STATUS.INSTALLED,      // ← AÑADIDO
  PROJECT_STATUS.COMPLETED,
];

export const createProject = (data) => ({
  id: '',
  
  // Relación con contrato
  contractId: data.contractId || '',
  contractTitle: data.contractTitle || '',
  contractSignedDate: data.contractSignedDate || '',
  
  // Datos del proyecto
  name: data.name || '',
  description: data.description || '',
  
  // Datos del cliente (del contrato)
  clientId: data.clientId || '',
  clientName: data.clientName || '',
  clientPhone: data.clientPhone || '',
  
  // Dirección
  address: {
    street: data.address?.street || '',
    city: data.address?.city || '',
    province: data.address?.province || '',
    zipCode: data.address?.zipCode || '',
    country: data.address?.country || 'España',
  },
  
  // Tipo de instalación
  installationType: data.installationType || INSTALLATION_TYPES.PHOTOVOLTAIC,
  
  // Boleanos de estado
  hasFileOpened: data.hasFileOpened || false,
  hasLicensePermit: data.hasLicensePermit || false,
  materialPurchased: data.materialPurchased || false,
  laborHired: data.laborHired || false,
  materialReceived: data.materialReceived || false,
  liftingEquipmentRented: data.liftingEquipmentRented || false,
  installed: data.installed || false,
  
  // Estado general
  status: data.status || PROJECT_STATUS.MANAGING,
  
  // Total acumulado de facturas asociadas
  totalInvoiced: data.totalInvoiced || 0,
  
  // Fechas
  startDate: data.startDate || '',
  endDate: data.endDate || '',
  installationDate: data.installationDate || '',
  
  // Proceso (texto)
  process: data.process || 'Apertura expediente, licencia de obra, recursos comprados, recursos coordinados, instalación hecha.',
  
  // Boletín/Proyecto - Enlaces
  hasBulletinRequested: data.hasBulletinRequested || false,
  hasBulletinReceived: data.hasBulletinReceived || false,
  bulletinLink: data.bulletinLink || '',
  bulletinFileName: data.bulletinFileName || '',
  
  // Requerimiento - Enlaces
  hasRequirement: data.hasRequirement || false,
  requirementLink: data.requirementLink || '',
  requirementFileName: data.requirementFileName || '',
  requirementReminderDate: data.requirementReminderDate || '',
  
  // Archivos
  files: data.files || [],
  
  // Presupuesto
  budget: data.budget || 0,
  
  // Equipo
  team: data.team || [],
  
  // Notas
  notes: data.notes || '',
  
  // Metadata
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: '',
  isActive: true
});
export const createTask = (data) => ({
  id: '',
  title: data.title || '',
  description: data.description || '',
  projectId: data.projectId || '',
  assignedTo: data.assignedTo || '',
  priority: data.priority || TASK_PRIORITY.MEDIUM,
  status: data.status || TASK_STATUS.TODO,
  dueDate: data.dueDate || '',
  estimatedHours: data.estimatedHours || 0,
  createdAt: new Date().toISOString()
});